// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "aside.app-drawer.v-navigation-drawer {\n  margin-top: 70px !important;\n}\n/*# sourceMappingURL=src/nms/layouts/left_bar.css.map */", "",{"version":3,"sources":["/project/src/nms/layouts/left_bar.vue"],"names":[],"mappings":"AAEA;EACE,2BAAW;AADb;AACA,uDAAuD","file":"left_bar.vue","sourcesContent":["\n\naside.app-drawer.v-navigation-drawer\n  margin-top 70px !important\n\n"]}]);
// Exports
module.exports = exports;
